import { type ProductDiscountBoundaries } from './components/ProductConfigProvider'

/**
 * Check a discount value against tenant discount boundaries configuration
 *
 * @param discount Discount value in percents, example `30` is 30%
 * @param discountBoundaries Tenant specific discount boundaries configuration
 */
export const productIsValidDiscount = (
  discount: number,
  discountBoundaries: ProductDiscountBoundaries = {},
): boolean => {
  if (Number.isNaN(discount) || discount <= 0) {
    return false
  }

  const { max = Number.POSITIVE_INFINITY, min = Number.NEGATIVE_INFINITY } =
    discountBoundaries

  return discount >= min && discount <= max
}
